module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAIklEQVR42mP8//8/AymAiYFEQHsNLIyDzkkjUgPL/6HvBwAgJAQhTNcyPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_mpb.png
// module id = POFW
// module chunks = 0